<template>
  <div class="export-voucher-container">
    <div class="header-container">
      <Header />
      <Banner />
    </div>
    <ServiceIntro />
    <ShortformMarketing />
    <TiktokAffiliate />
    <JapanAffiliate />
    <ConsultationForm />
    <Footer />
  </div>
</template>

<script>
import {
  Header,
  Banner,
  ServiceIntro,
  ShortformMarketing,
  TiktokAffiliate,
  JapanAffiliate,
  ConsultationForm,
  Footer,
} from '../../components/campaign/export-voucher';

export default {
  name: 'ExportVoucher',
  components: {
    Header,
    Banner,
    ServiceIntro,
    ShortformMarketing,
    TiktokAffiliate,
    JapanAffiliate,
    ConsultationForm,
    Footer,
  },

  created() {
    window.dataLayer.push({
      event: 'onboardLanding',
      page: 'exportVoucher',
    });
  },
};
</script>

<style scoped lang="scss">
:deep(*) {
  font-family: 'Pretendard';
}

.export-voucher-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 960px) {
    overflow-x: hidden;
  }
}

.header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #001669 0.19%, #38b2e6 99.86%);
}
</style>
